import sofiaREILogo from "@/assets/icons/rei.svg?sprite"

import { sofiaRei } from "@/constants/sideBarMenus"

export function getCurrentModule (path)  {
  return {
    name: 'sofiaRei',
    logo: sofiaREILogo,
    menu: [ ...sofiaRei ]
  }
};
